import apiClient from './apiClient';

export const leaderApi = {
    // ---- Workers (Unified with Employee Tool) ----
    getWorkers: () => apiClient.get('/api/employee').then(res => res.data),
    createWorker: (data) => apiClient.post('/api/employee', data).then(res => res.data),
    updateWorker: (id, data) => apiClient.put(`/api/employee/${id}`, data).then(res => res.data),
    deleteWorker: (id) => apiClient.delete(`/api/employee/${id}`).then(res => res.data),
    syncUsers: () => apiClient.post('/api/employee/sync-users').then(res => res.data),

    // ---- Vehicles ----
    getVehicles: () => apiClient.get('/api/leader/vehicles').then(res => res.data),
    createVehicle: (data) => apiClient.post('/api/leader/vehicles', data).then(res => res.data),
    updateVehicle: (id, data) => apiClient.put(`/api/leader/vehicles/${id}`, data).then(res => res.data),
    deleteVehicle: (id) => apiClient.delete(`/api/leader/vehicles/${id}`).then(res => res.data),

    // ---- Kolonnen ----
    getKolonnen: () => apiClient.get('/api/leader/kolonnen').then(res => res.data),
    createKolonne: (data) => apiClient.post('/api/leader/kolonnen', data).then(res => res.data),
    updateKolonne: (id, data) => apiClient.put(`/api/leader/kolonnen/${id}`, data).then(res => res.data),
    deleteKolonne: (id) => apiClient.delete(`/api/leader/kolonnen/${id}`).then(res => res.data),

    // ---- Assignments ----
    getAssignments: (params) => apiClient.get('/api/leader/assignments', { params }).then(res => res.data),
    getAssignment: (id) => apiClient.get(`/api/leader/assignments/${id}`).then(res => res.data),
    createAssignment: (data) => apiClient.post('/api/leader/assignments', data).then(res => res.data),
    updateAssignment: (id, data) => apiClient.put(`/api/leader/assignments/${id}`, data).then(res => res.data),
    deleteAssignment: (id) => apiClient.delete(`/api/leader/assignments/${id}`).then(res => res.data),
    createMultipleAssignments: async (entries) => {
        const results = await Promise.all(
            entries.map(entry => apiClient.post('/api/leader/assignments', entry).then(res => res.data))
        );
        return results;
    },
    updateMultipleAssignments: async (updates) => {
        const results = await Promise.all(
            updates.map(u => apiClient.put(`/api/leader/assignments/${u.id}`, u).then(res => res.data))
        );
        return results;
    },

    // ---- Worker Absences ----
    getAbsences: (params) => apiClient.get('/api/leader/absences', { params }).then(res => res.data),
    getWorkerAbsences: (workerId, params) => apiClient.get(`/api/leader/workers/${workerId}/absences`, { params }).then(res => res.data),
    createWorkerAbsence: (workerId, data) => apiClient.post(`/api/leader/workers/${workerId}/absences`, data).then(res => res.data),
    updateAbsence: (id, data) => apiClient.put(`/api/leader/absences/${id}`, data).then(res => res.data),
    deleteAbsence: (id) => apiClient.delete(`/api/leader/absences/${id}`).then(res => res.data),

    // ---- Vehicle Categories ----
    getVehicleCategories: () => apiClient.get('/api/leader/vehicle-categories').then(res => res.data),
    createVehicleCategory: (data) => apiClient.post('/api/leader/vehicle-categories', data).then(res => res.data),
    updateVehicleCategory: (id, data) => apiClient.put(`/api/leader/vehicle-categories/${id}`, data).then(res => res.data),
    deleteVehicleCategory: (id, force = false) => apiClient.delete(`/api/leader/vehicle-categories/${id}?force=${force}`).then(res => res.data),

    // ---- Overview & Settings ----
    getSettings: () => apiClient.get('/api/leader/settings').then(res => res.data),
    updateSettings: (data) => apiClient.put('/api/leader/settings', data).then(res => res.data),
    calculateRoute: (params) => apiClient.get('/api/leader/route', { params }).then(res => res.data),

    // ---- Draft Notes ----
    getDraftNotes: () => apiClient.get('/api/leader/draft-notes').then(res => res.data),
    getDraftNotesReminders: () => apiClient.get('/api/leader/draft-notes/reminders').then(res => res.data),
    createDraftNote: (data) => apiClient.post('/api/leader/draft-notes', data).then(res => res.data),
    updateDraftNote: (id, data) => apiClient.put(`/api/leader/draft-notes/${id}`, data).then(res => res.data),
    deleteDraftNote: (id) => apiClient.delete(`/api/leader/draft-notes/${id}`).then(res => res.data),

    // ---- Conflicts & Availability ----
    checkWorkerBooking: (data) => apiClient.post('/api/leader/conflicts/check-worker-booking', data).then(res => res.data),
    checkAbsenceConflict: (data) => apiClient.post('/api/leader/conflicts/check-absence', data).then(res => res.data),
    checkVehicleAvailability: (params) => apiClient.get('/api/leader/vehicles/availability', { params }).then(res => res.data),
};
